import { render, staticRenderFns } from "./DetailTwo.vue?vue&type=template&id=8181ffb0&scoped=true"
import script from "./DetailTwo.vue?vue&type=script&lang=js"
export * from "./DetailTwo.vue?vue&type=script&lang=js"
import style0 from "./DetailTwo.vue?vue&type=style&index=0&id=8181ffb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8181ffb0",
  null
  
)

export default component.exports